import script from "./AccountLockedView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountLockedView.vue?vue&type=script&setup=true&lang=js"

import "./AccountLockedView.vue?vue&type=style&index=0&id=1266a3f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1266a3f2"]])

export default __exports__